import { useCallback, useEffect, useRef, useState } from 'react';

import { events } from '../../domain/services/api';
import crmOrbitaConnectionService from '../../domain/services/crm/crm.orbita.connection.service';
import {
    ORBITA_CONNECTION_RECHECK_MS,
    ORBITA_DISCONNECTED_EVENT
} from '../../domain/constant/crm/crm.orbita.connection.constant';

const useOrbitaConnectionGate = (enabled) => {
    const [blocked, setBlocked] = useState(false);
    const [checking, setChecking] = useState(false);
    const [stillDisconnected, setStillDisconnected] = useState(false);
    const mountedRef = useRef(true);

    const check = useCallback(async () => {
        const state = await crmOrbitaConnectionService.findState();
        if (mountedRef.current) setBlocked(state.blocked);
        return state;
    }, []);

    const recheck = useCallback(async () => {
        setChecking(true);
        setStillDisconnected(false);
        const state = await check();
        if (!mountedRef.current) return;
        setChecking(false);
        setStillDisconnected(state.blocked);
    }, [check]);

    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (!enabled) {
            setBlocked(false);
            return undefined;
        }

        const onDisconnected = () => setBlocked(true);

        check();
        const interval = setInterval(check, ORBITA_CONNECTION_RECHECK_MS);
        window.addEventListener('focus', check);
        events.on(ORBITA_DISCONNECTED_EVENT, onDisconnected);

        return () => {
            clearInterval(interval);
            window.removeEventListener('focus', check);
            events.removeListener(ORBITA_DISCONNECTED_EVENT, onDisconnected);
        };
    }, [enabled, check]);

    return { blocked: enabled && blocked, checking, stillDisconnected, recheck };
};

export default useOrbitaConnectionGate;
